/**
 * Wire-format mirror of the Prisma `AdminPermission` enum.
 *
 * The admin SPA MUST NOT import `@prisma/client` (server-only dep) yet
 * still needs the canonical permission strings for `usePermissions`,
 * `<RequirePermission>`, `<RedactedField>`, and the TOTP step-up
 * `purpose`. This string-union is the single source of truth shared
 * across api / admin so the two never drift.
 *
 * Source: `packages/api/prisma/schema.prisma` `enum AdminPermission`
 * (9 values, 2026-05-26). `view_pii` is reserved ahead of the backend
 * adding it (per ADMIN-10 ticket) — Phase B proxies it via
 * `manage_users` / `verify_inspectors` at the call site until the
 * backend ships it. Adding it here now means `<RedactedField perm="view_pii">`
 * type-checks today without a follow-up wire change.
 *
 * Wire-stable: renaming / removing a value is a breaking change that
 * must be coordinated across api + admin.
 */
export const ADMIN_PERMISSIONS = [
    'manage_orders',
    'moderate_reports',
    'resolve_appeals',
    'verify_inspectors',
    'process_payouts',
    'manage_users',
    'view_analytics',
    'manage_settings',
    'manage_admins',
    'view_pii',
];
/**
 * Runtime type-guard — narrows an arbitrary string to `AdminPermission`.
 * Useful when deserialising a permission list off the wire before
 * trusting it (e.g. mapping `/admin/me`).
 */
export const isAdminPermission = (value) => ADMIN_PERMISSIONS.includes(value);
//# sourceMappingURL=admin-permission.js.map